import {
  POST_YADS_INGESTION_REQUEST,
  POST_YADS_INGESTION_SUCCESS,
  POST_YADS_INGESTION_FAILURE,
  POST_YADS_INGESTION_RESET
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  ingestionResult: null,
  error: '',
};

const yadsIngestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case POST_YADS_INGESTION_REQUEST:
      return { ...state, loading: true };
    case POST_YADS_INGESTION_SUCCESS:
      return { loading: false, ingestionResult: action.payload, error: '' };
    case POST_YADS_INGESTION_FAILURE:
      return { loading: false, ingestionResult: null, error: action.payload };
      case POST_YADS_INGESTION_RESET:
  return { ...state, ingestionResult: null, error: '' };
    default:
      return state;
  }
};

export default yadsIngestionReducer;
